import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { ImageService } from "src/app/services/imagen.service";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
})
export class ErrorComponent implements OnInit {
  textError: string = "";
  showError: boolean = false;
  subscription: Subscription;

  constructor(private _imageService: ImageService) {
    this.subscription = this._imageService.getError().subscribe((error) => {
      this.textError = error;
      this.showMessage();
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  showMessage() {
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 3000);
  }
}
